import { language } from 'curvy';

export const english: language.TranslationDefinition = {
    locale: 'en-us',
    translations: {
        "COMMENTS.TAB.INTERNAL": "Leave internal comment",
        "COMMENTS.TAB.PUBLIC": "Leave public comment",
        "COMMENTS.INTERNAL_COMMENT": "Internal comment",
        "COMMENTS.IS_PUBLIC_INFO": "You are leaving a public comment that will be visible to all users",
    }
};

export const croatian: language.TranslationDefinition = {
    locale: 'hr-hr',
    translations: {
        "COMMENTS.TAB.INTERNAL": "Ostavi interni komentar",
        "COMMENTS.TAB.PUBLIC": "Ostavi javni komentar",
        "COMMENTS.INTERNAL_COMMENT": "Interni komentar",
        "COMMENTS.IS_PUBLIC_INFO": "Ostavljate javni komentar koji će biti vidljiv svim korisnicima",
    }
};

export const comments_translations = [english, croatian];
